import React, {Component, Fragment} from 'react';
import CsodTableRow from "./CsodTableRow";
import CsodTableHeader from "./CsodTableHeader";

//import {connect} from "react-redux";

class CsodTable extends Component {

    render() {
        const {data} = this.props;
        if (data.length > 0) {
            return (
                <Fragment>
                    <table className="cso-tbl-std cso-tbl100 c-cell-pad-xsmall tl-auto" id="tblEmail">
                        <tbody>
                        <CsodTableHeader rowItem={Object.keys(data[0])}/>
                        {data.map((item, index) => {
                            return (<CsodTableRow key={index} rowItem={item}/>)
                        })}
                        </tbody>
                    </table>
                </Fragment>


            );
        } else {
            return (
                <p>
                    No data.
                </p>
            );
        }
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default CsodTable;


// WEBPACK FOOTER //
// ./src/widgets/components/Csod/CsodTable.js